<template>
    <div class="jump-page">
        <div class="main-container">
            <div class="center-con">
                <div class="icon"></div>
                <div class="txtlist">
                    <div class="t0">正在跳转至课程观看页面....</div>
                    <div class="t1">跳转后，请使用中国职工教育网注册手机号进行登录。</div>
                    <div class="t3">注意：</div>
                    <div class="t4">
                        <div class="label">1.</div>
                        <div class="txt">跳转后，默认是未登录状态，页面会显示立即购买的按钮，请先进行登录（登录手机号与兑换手机号必须相同），登录后即可观看课程，无需重复购买课程。</div>
                    </div>
                    <div class="t5">
                        <div class="label">2.</div>
                        <div class="txt">在微信环境授权登录后，会提示选择一个账号作为主账号，请选择【当前账号】即可，请勿选择【冲突账号】。（主账号一般为微信账号授权，请确认微信授权的手机号与兑换课程手机号相同，否则无法查看课程，如微信授权手机号与兑换手机号不同，请直接用兑换手机号登录小鹅通）</div>
                    </div>
                </div>
                <div class="btn-list">
                    <div class="btnhome" @click="onHome">返回首页</div>
                    <div class="btngo" @click="onJump">点击前往</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            spu_id: ''
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    beforeUnmount() {},
    created() {
        if (!this.$route.query.spu_id) {
            this.$router.replace('/')
            return false
        }
        this.spu_id = this.$route.query.spu_id
    },
    mounted() {},
    methods: {
        onJump() {
            window.location.href = 'https://appnycktuco1506.h5.xiaoeknow.com/p/course/video/' + this.spu_id
        },
        onHome() {
            this.$router.replace('/')
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 0.8;
$s750: 1;
.jump-page {
    line-height: 1.5;
    background-color: #fff;
    min-height: 100vh;
    position: relative;
    .main-container {
        .center-con {
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            width: 100%;
            max-width: 7.18rem;
            @media screen and (max-width: 1024px) {
                max-width: (10rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                max-width: (6rem * $s750);
            }
            .icon {
                width: 1.27rem;
                height: 1.27rem;
                background: url(../assets/icon_web.png) no-repeat center center;
                background-size: contain;
                margin: 0 auto;
            }
            .txtlist {
                color: #222529;
                text-align: center;

                line-height: 2;
                margin: 0.2rem 0;
                @media screen and (max-width: 1024px) {
                }
                @media screen and (max-width: 750px) {
                    margin: (0.2rem * $s750);
                }
                .t0 {
                    word-break: keep-all;
                    word-wrap: normal;
                    white-space: nowrap;
                    font-size: 0.21rem;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.25rem * $s750);
                    }
                }
                .t1 {
                    word-break: keep-all;
                    word-wrap: normal;
                    white-space: nowrap;
                    font-size: 0.21rem;
                    font-weight: bold;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.25rem * $s750);
                    }
                }
                .t3 {
                    word-break: keep-all;
                    word-wrap: normal;
                    white-space: nowrap;
                    font-size: 0.17rem;
                    font-weight: bold;
                    margin-top: 0.2rem;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.28rem * $s750);
                        margin-top: (0.4rem * $s750);
                    }
                }
                .t4 {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    font-size: 0.14rem;
                    margin-top: 0rem;
                    line-height: 2;
                    text-align: left;
                    color: #000000;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.2rem * $s750);
                    }
                }
                .t5 {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    font-size: 0.14rem;
                    margin-top: 0.15rem;
                    line-height: 2;
                    text-align: left;
                    color: #000000;
                    margin-bottom: 0.05rem;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.2rem * $s750);
                        margin-top: (0.1rem * $s750);
                        margin-bottom: (0.2rem * $s750);
                    }
                }
            }
            .btn-list {
                display: flex;
                flex-direction: row;
                justify-content: center;
                .btngo {
                    width: 0.9rem;
                    height: 0.4rem;
                    border-radius: 0.1rem;
                    background-color: #222529;
                    font-size: 0.14rem;
                    color: #ffffff;
                    text-align: center;
                    line-height: 0.4rem;
                    cursor: pointer;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        width: (1.5rem * $s750);
                        height: (0.7rem * $s750);
                        border-radius: (0.2rem * $s750);
                        font-size: (0.23rem * $s750);
                        line-height: (0.7rem * $s750);
                    }
                }
                .btnhome {
                    width: 0.9rem;
                    height: 0.4rem;
                    border-radius: 0.1rem;
                    background-color: #eb2234;
                    font-size: 0.14rem;
                    color: #ffffff;
                    text-align: center;
                    line-height: 0.4rem;
                    cursor: pointer;
                    margin-right: 0.2rem;
                    @media screen and (max-width: 1024px) {
                    }
                    @media screen and (max-width: 750px) {
                        width: (1.5rem * $s750);
                        height: (0.7rem * $s750);
                        border-radius: (0.2rem * $s750);
                        font-size: (0.23rem * $s750);
                        line-height: (0.7rem * $s750);
                        margin-right: (0.2rem * $s750);
                    }
                }
            }
        }
    }
}
</style>
